// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabText {
  color: transparent;

  background-image: linear-gradient(90deg, #252325ff 50%, #666566ff 50%);
  background-position: 100%;
  background-size: 200% 100%;
  background-clip: text;
  -webkit-background-clip: text;
  transition: background-position 1s ease;
}
.tabText:hover {
  background-position: 0;
}
.underline-effect {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.underline-effect::before {
  content: "";
  position: absolute;
  width: 0;
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: red;
  visibility: hidden;
  transition: all 0.3s;
}
.underline-effect-active {
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.underline-effect-active::before {
  content: "";
  position: absolute;

  height: 6px;
  bottom: 0;
  left: 0;
  background-color: black;
  visibility: visible;
  width: 100%;
  transition: all 0.3s;
}
.underline-effect-active:hover::before {
  width: 0%;
  visibility: hidden;
}
.underline-effect:hover::before {
  width: 100%;
  visibility: visible;
}

.titleText {
  color: transparent;

  background-image: linear-gradient(90deg, #f5227fff 50%, #252325ff 50%);
  background-position: 100%;
  background-size: 200% 100%;
  background-clip: text;
  -webkit-background-clip: text;
  transition: background-position 1s ease;
}
.titleText:hover {
  background-position: 0;
}
.truncateTitle {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4; /* Number of lines you want to display */
  overflow: hidden;
}
.truncateContent {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* Number of lines you want to display */
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/components/css/text.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;;EAElB,sEAAsE;EACtE,yBAAyB;EACzB,0BAA0B;EAC1B,qBAAqB;EACrB,6BAA6B;EAC7B,uCAAuC;AACzC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,OAAO;EACP,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;;EAElB,WAAW;EACX,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;;EAElB,sEAAsE;EACtE,yBAAyB;EACzB,0BAA0B;EAC1B,qBAAqB;EACrB,6BAA6B;EAC7B,uCAAuC;AACzC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB,EAAE,wCAAwC;EAC/D,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB,EAAE,wCAAwC;EAC/D,gBAAgB;AAClB","sourcesContent":[".tabText {\n  color: transparent;\n\n  background-image: linear-gradient(90deg, #252325ff 50%, #666566ff 50%);\n  background-position: 100%;\n  background-size: 200% 100%;\n  background-clip: text;\n  -webkit-background-clip: text;\n  transition: background-position 1s ease;\n}\n.tabText:hover {\n  background-position: 0;\n}\n.underline-effect {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.underline-effect::before {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 2px;\n  bottom: 0;\n  left: 0;\n  background-color: red;\n  visibility: hidden;\n  transition: all 0.3s;\n}\n.underline-effect-active {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n.underline-effect-active::before {\n  content: \"\";\n  position: absolute;\n\n  height: 6px;\n  bottom: 0;\n  left: 0;\n  background-color: black;\n  visibility: visible;\n  width: 100%;\n  transition: all 0.3s;\n}\n.underline-effect-active:hover::before {\n  width: 0%;\n  visibility: hidden;\n}\n.underline-effect:hover::before {\n  width: 100%;\n  visibility: visible;\n}\n\n.titleText {\n  color: transparent;\n\n  background-image: linear-gradient(90deg, #f5227fff 50%, #252325ff 50%);\n  background-position: 100%;\n  background-size: 200% 100%;\n  background-clip: text;\n  -webkit-background-clip: text;\n  transition: background-position 1s ease;\n}\n.titleText:hover {\n  background-position: 0;\n}\n.truncateTitle {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 4; /* Number of lines you want to display */\n  overflow: hidden;\n}\n.truncateContent {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2; /* Number of lines you want to display */\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
